import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOGOUT } from '../../constants/actions/auth.constants';

const NAME = 'QUESTIONNAIRE';

type State = {
    loading: boolean;
};

const initialState: State = {
    loading: false,
};

const setLoading = createAction<boolean>(`${NAME}/setLoading`);

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        closeQuestionnaire: (state: State) => {
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            setLoading.type,
            (state: State, action: PayloadAction<boolean>) => {
                state.loading = action.payload;
            },
        );

        builder.addCase(LOGOUT, (state: State) => {
            state.loading = false;
        });
    },
});

const QuestionnaireActions = {
    ...slice.actions,
    setLoading,
};

export default QuestionnaireActions;
export const QuestionnaireReducer = slice.reducer;
